import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router } from '@angular/router';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//baseclasses
import { BaseGridComponent } from '../../baseclasses/BaseGrid.component';

@Component({
    selector: 'my-customer-grid',
    templateUrl: './CustomerGrid.component.html',
    providers: [{ provide: BaseGridComponent, useExisting: forwardRef(() => CustomerGridComponent) }]
})
export class CustomerGridComponent extends BaseGridComponent {
    records: ent.Customer[] = [];
    selectedRecords: ent.Customer[] = [];
    @Input() public showLinkToSelf: boolean;
    @Input() public showSelectionCheckbox: boolean;
    @Input() public showSelectionButton: boolean;
    @Output() onCustomerSelected = new EventEmitter<ent.Customer>();

    cols: any[];


    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) {
        super();
    }


    ngOnInit(): void {

        this.loadColumns();
    }


    loadColumns() {

        this.cols = [];
        // if (this.showLinkToSelf){ this.cols.push({ field: 'LinkToSelf', header: 'Link To Self' });}  

        this.cols.push({ field: 'CustomerNumber', header: 'Customer #', width: '7em' });
        this.cols.push({ field: 'Name', header: 'Name' });
        this.cols.push({ field: 'PYPayerNumber', header: 'Payer #', width: '7em' });
        this.cols.push({ field: 'StreetAddress', header: 'Address' });
        this.cols.push({ field: 'City', header: 'City' });
        this.cols.push({ field: 'StateProvince', header: 'State/Province', width: '7em' });
        this.cols.push({ field: 'PostalCode', header: 'Postal Code', width: '7em' });

    }

    onSelectCustomer(event: any, customer: ent.Customer) {
        this.onCustomerSelected.emit(customer);
    }
}